import React, { useState, useEffect } from "react";

import "../../CSS/Menu.css";

import DesktopNavbar from "./DesktopNavbar";
import MobileNavbar from "./MobileNavbar";

const items = [
  "MainPage",
  "Education",
  "Skills",
  "Projects",
  "WorkExperience",
  "AboutMe",
  "ContactMe",
];

export default function Menu() {
  const [mobileView, setMobileView] = useState();

  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 900
        ? setMobileView(true)
        : setMobileView(false);
    };

    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());

    return () => {
      window.removeEventListener("resize", () => setResponsiveness());
    };
  }, []);

  return (
    <>
      {mobileView ? (
        <MobileNavbar items={items} />
      ) : (
        <DesktopNavbar items={items} />
      )}
    </>
  );
}
